import Vue from 'vue'

export default new Vue()


// WEBPACK FOOTER //
// ./resources/assets/js/bus.js